var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"summary",attrs:{"rounded":"rounded-lg","color":"#2E3944"}},[_c('v-card-title',{staticClass:"summary-title"},[_vm._v(" "+_vm._s(this.title)+" ")]),_c('v-card-text',{staticClass:"summary-text",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }